import {useAtom} from "jotai";
import TableDragSelect from "react-table-drag-select";
import "../../assets/dragSelect.css";
import {
  timeBudgetDetailDataAtom,
  timesInfo,
  weeksInfo
} from "../../pages/settings/entity/BudgetTime";
import styled from "styled-components";

export default function DragToSelect({
  readOnly = false
}) {
  const [
    timeBudgetDetailDataState,
    setTimeBudgetDetailDataState
  ] = useAtom(timeBudgetDetailDataAtom);

  const allowTimes =
      timeBudgetDetailDataState?.allowTimes ??
      Array.from(
          {length: 7},
          () =>
              Array.from(
                  {length: 24},
                  () => false
              )
      );

  const handleChangeCells = cells => {
    if (readOnly) {
      return;
    }

    setTimeBudgetDetailDataState(prev => ({
      ...prev,
      allowTimes: cells
    }));
  };

  const renderCells = () =>
      Array.from(
          {length: 7},
          (_, weekIndex) => (
              <tr key={weekIndex}>
                {Array.from(
                    {length: 24},
                    (_, timeIndex) => (
                        <td
                            key={`${weekIndex}-${timeIndex}`}
                            className={`col${timeIndex}`}
                        />
                    )
                )}
              </tr>
          )
      );

  return (
      <TimeScheduleArea
          $readOnly={readOnly}
      >
        <TimeHeaderRow>
          <WeekHeaderSpacer />

          <TimeHeader>
            {timesInfo.map(
                (data, index) => (
                    <TimeHeaderItem
                        key={
                            data.time ??
                            index
                        }
                    >
                      <TimeValue>
                        {data.time}
                        {data.label}
                      </TimeValue>
                    </TimeHeaderItem>
                )
            )}
          </TimeHeader>
        </TimeHeaderRow>

        <ScheduleGridRow>
          <WeekColumn>
            {weeksInfo.map(
                (data, index) => (
                    <WeekItem
                        key={
                            data.week ??
                            index
                        }
                    >
                      {data.week}
                    </WeekItem>
                )
            )}
          </WeekColumn>

          <DragTableWrap>
            <TableDragSelect
                value={allowTimes}
                onChange={
                  handleChangeCells
                }
            >
              {renderCells()}
            </TableDragSelect>
          </DragTableWrap>
        </ScheduleGridRow>

        {readOnly && (
            <ReadOnlyGuide>
              읽기 전용 시간 설정입니다.
            </ReadOnlyGuide>
        )}
      </TimeScheduleArea>
  );
}

const TimeScheduleArea = styled.div`
  width: 100%;
  min-width: 940px;

  ${({$readOnly}) =>
          $readOnly &&
          `
      opacity: 0.85;

      table {
        pointer-events: none;
      }
    `}
`;

const TimeHeaderRow = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 6px;
`;

const WeekHeaderSpacer = styled.div`
  width: 62px;
  min-width: 62px;
`;

const TimeHeader = styled.div`
  display: grid;
  grid-template-columns:
    repeat(24, minmax(32px, 1fr));
  flex: 1;
  gap: 3px;
`;

const TimeHeaderItem = styled.div`
  display: flex;
  min-width: 0;
  height: 38px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  background-color: #f7f7f7;
`;

const TimeValue = styled.span`
  color: #444;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.1;
`;

const TimeLabel = styled.span`
  color: #999;
  font-size: 9px;
  line-height: 1.1;
`;

const ScheduleGridRow = styled.div`
  display: flex;
  width: 100%;
`;

const WeekColumn = styled.div`
  display: grid;
  grid-template-rows:
    repeat(7, 38px);
  width: 62px;
  min-width: 62px;
  gap: 3px;
  padding-right: 6px;
`;

const WeekItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  background-color: #f7f7f7;
  color: #555;
  font-size: 12px;
  font-weight: 600;
`;

const DragTableWrap = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  border: 1px solid #e5e5e5;
  border-radius: 7px;
  background-color: #fff;

  table {
    width: 100%;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 3px;
    padding: 3px;
    background-color: #fff;
  }

  tbody,
  tr {
    width: 100%;
  }

  td {
    height: 35px;
    padding: 0;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    background-color: #fff;
    cursor: pointer;
    transition:
      border-color 0.15s ease,
      background-color 0.15s ease;
  }

  td:hover {
    border-color: #f5811f;
    background-color: #fff8f1;
  }

  /*
   * react-table-drag-select에서 선택된 셀에
   * 기본적으로 selected 클래스를 부여하는 경우 적용됩니다.
   */
  td.selected,
  .selected {
    border-color: #f5811f !important;
    background-color: #fff4e8 !important;
  }
`;

const ReadOnlyGuide = styled.div`
  margin-top: 8px;
  color: #999;
  font-size: 11px;
  text-align: right;
`;